var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 518,
    viewBox: "0 0 238 518",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2298_710",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 238,
    height: 518
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 237.23,
    height: 517.422,
    rx: 26.6689,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2298_710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08008 76.6889C1.08008 59.1334 15.3116 44.9019 32.8671 44.9019H206.293C223.849 44.9019 238.08 59.1334 238.08 76.6889V486.115C238.08 503.67 223.849 517.902 206.293 517.902H32.8671C15.3116 517.902 1.08008 503.67 1.08008 486.115V76.6889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2298_710)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2298_710)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 117.98,
    cy: -146.798,
    r: 284,
    fill: "url(#paint0_linear_2298_710)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2298_710",
    x: -516.02,
    y: -780.798,
    width: 1268,
    height: 1268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_2298_710"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2298_710",
    x1: 401.98,
    y1: -148.841,
    x2: -166.02,
    y2: -148.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2298_710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 479,
    fill: "white",
    transform: "translate(-1.91992 -2.09814)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/Screen.439134d4db640ddb6833a6148384dee9.svg";
export { ForwardRef as ReactComponent };